// extracted by mini-css-extract-plugin
module.exports = {"strength":"_af28c6d"};